/* eslint-disable camelcase */
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSchemaAddParticipant = () => {
  const { t } = useTranslation();

  const addParticipantSchema = yup.object().shape({
    // createInvoice: yup.boolean(),
    participants: yup.array().of(
      yup.object().shape({
        event_id: yup.number().required(),
        member_id: yup.number().required(),
        email: yup.string().email(t('event:validationMessage.validEmail')).required(t('event:validationMessage.fieldRquired')),
        firstName: yup.string().required(t('event:validationMessage.fieldRquired')),
        lastName: yup.string().required(t('event:validationMessage.fieldRquired')),
        fee: yup.number().optional(),
        allergy: yup.string().optional(),
        phone: yup.string().optional(),
      }),
    ),
  });
  return addParticipantSchema;
};
